"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyRoutes = void 0;
const route_1 = require("../route");
class CurrencyRoutes extends route_1.Route {
    constructor() {
        super('currencies');
    }
    getExchangeRate(from, to) {
        return this.get('/exchange-rate', { from, to });
    }
    getExchangeRateDetails(from, to) {
        return this.get('/exchange-rate-details', { from, to });
    }
    getExchangeRates(from) {
        return this.get('/exchange-rates', { from });
    }
}
exports.CurrencyRoutes = CurrencyRoutes;
//# sourceMappingURL=currencies.js.map